import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nZh from '~/lang/zh'
import i18nEn from '~/lang/en'
import viewUI from 'view-design'
// 将 iview 国际化与 i18n 结合
import en from 'view-design/dist/locale/en-US'
import zh from 'view-design/dist/locale/zh-CN'

import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

// iview国际化会导致 js 唤起 Modal 报错，待处理
// Vue.locale = () => {}

export default ({
  app,
  store
}) => {
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch
  const i18n = new VueI18n({
    locale: store.state.locale, // 语言包
    fallbackLocale: 'en', // 默认语言设置，当其他语言没有的情况下，使用en作为默认语言
    messages: {
      zh: Object.assign(i18nZh, zh, zhLocale),
      en: Object.assign(i18nEn, en, enLocale)
    }
  })
  app.i18n = i18n
  Vue.use(Element, { zIndex: 100000, i18n: (key, value) => i18n.t(key, value) })
  // 再此注册 viewUi，与vue-i18n结合（原因：因为需要在i18n挂在到Vue之后在进行结合）
  Vue.use(viewUI, {
    i18n: (key, value) => i18n.t(key, value)
  })
  // 自定义path方法，用于处理router中的path
  // **router.push(path)中的path必须以"/"开头**
  app.i18n.path = (path) => {
    // 如果是默认语言，就省略
    if (app.i18n.locale === app.i18n.fallbackLocale) {
      return `${path}`
    }
    return `/${app.i18n.locale}${path}`
  }
}
